import { useEffect, useLayoutEffect } from 'react';
import { StorageKeys } from '@/shared/types';
import { ThemeContextType, useThemeContext } from './ThemeProvider';

const getBrowserTheme = () =>
  window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const useThemeSetup = (isAuthenticated: boolean) => {
  const { theme, setTheme } = useThemeContext();

  useLayoutEffect(() => {
    if (isAuthenticated) {
      const savedTheme = localStorage.getItem(StorageKeys.Theme);
      if (savedTheme) {
        setTheme(savedTheme as ThemeContextType['theme']);
        return;
      }
      const browserTheme = getBrowserTheme();
      setTheme(browserTheme);
    }
  }, [isAuthenticated, setTheme]);

  useEffect(() => {
    if (isAuthenticated) {
      const savedTheme = localStorage.getItem(StorageKeys.Theme);
      if (savedTheme !== theme) {
        localStorage.setItem(StorageKeys.Theme, theme);
      }
    }
  }, [isAuthenticated, theme]);

  return theme;
};
